import React from 'react';

interface SprayNozzleProps {
  className?: string;
}

export function SprayNozzle({ className = "h-5 w-5" }: SprayNozzleProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Nozzle body */}
      <path d="M10 2h4v6h-4z" />
      
      {/* Nozzle opening */}
      <path d="M9 8h6l-1 2h-4z" />
      
      {/* Spray pattern - fan shape */}
      <line x1="12" y1="10" x2="12" y2="16" />
      <line x1="12" y1="11" x2="9" y2="17" />
      <line x1="12" y1="11" x2="15" y2="17" />
      <line x1="12" y1="12" x2="7" y2="19" />
      <line x1="12" y1="12" x2="17" y2="19" />
      
      {/* Droplets */}
      <circle cx="12" cy="21" r="1" />
      <circle cx="8" cy="22" r="0.5" />
      <circle cx="16" cy="22" r="0.5" />
    </svg>
  );
}

